<template>
  <div class="vx-row mb-2 -mt-1">
    <div class="vx-col w-full">
      <span class="text-xs">{{structure.label}}</span> <br>
      <flat-pickr v-model="localVal"   />
      <span class="text-danger text-sm" v-show="errors.has('field')">{{ errors.first('field') }}</span>
    </div>
  </div>
</template> 
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    flatPickr
  },
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true
    },
    value: String,
    validation: ""
  },
  data() {
    return {
      localVal: "",
      name: ""
    };
  },
  methods: {
    changeHandler() {
      // this.$emit("error", this.errors.errors);
      this.$validator.validateAll().then(result => {
        this.$emit("error", { index: this.index, value: result });
      });
    }
  },
  created() {
    if (this.value == undefined) {
      this.localVal = this.structure.value;
    } else {
      this.localVal = this.value;
    }

    if (this.localVal != "") {
      this.$emit("error", { index: this.index, value: true });
      this.$emit("input", { index: this.index, value: this.localVal });
    }

    this.$watch("localVal", value => {
      if (value != "") {
       
        this.$emit("input", { index: this.index, value: value });
        this.$emit("error", { index: this.index, value: true });
      } else {
        this.$emit("error", { index: this.index, value: false });
      }
    });
  }
};
</script>